export default __webpack_public_path__ + "static/media/SS3Regular.otf.b6f8fd0c.woff2";